import {observer} from 'mobx-react-lite'
import * as React from 'react'
import {useEffect, useState} from 'react'
import tw from 'tailwind-styled-components'
import {Lang} from 'yougile-lang'
import {DataObjectId} from 'yougile-model'
import {ProjectsTree} from '@components/common/projects-tree/projects-tree'
import {WithPerfectScrollbar} from '@components/common/with-scrollbar/with-scrollbar'
import {crmStore} from '@components/crm/crm-store'
import {LinkButtonWrapped} from '@components/movement-templates/link-button-wrapped'
import {useGlobalKeyDown} from '@containers/hooks'
import {useTaskTemplatesStore} from './task-templates-store'

const TwMainContainer = tw.div`
  flex
  flex-col
  h-full
`

const TwTitle = tw.div`
  flex
  items-center
  text-primary
  text-sm-semibold
  h-32
  mb-8
  cursor-default
`

export const TaskTemplatesExistence = observer(() => {
  const [, store] = useTaskTemplatesStore()
  const [selected, setSelected] = useState<DataObjectId>()

  useEffect(() => {
    if (selected) {
      store.goToCreateExist(selected)
    }
  }, [selected])

  useGlobalKeyDown({
    escape: store.cancel
  })

  const lang = Lang.msg.taskTemplates

  return (
    <WithPerfectScrollbar>
      <TwMainContainer>
        <LinkButtonWrapped
          icon={'IconCustomArrowLeft'}
          onMouseDown={store.goToMain}
          text={Lang.msg.taskTemplates.backToList}
          height={'h-32'}
          className={'mb-8'}
        />

        <TwTitle>{lang.existenceTitle}</TwTitle>

        {!selected && (
          <ProjectsTree
            value={selected ? [selected] : []}
            filterTasks={t => !crmStore.isDeal(t)}
            filterProjects={p => !crmStore.isCrmProject(p)}
            treeStyle={{height: 400}}
            onChange={x => setSelected(x[0])}
            oneSelectedItem
          />
        )}
      </TwMainContainer>
    </WithPerfectScrollbar>
  )
})
